import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import { setSelectedOptionId, subscribeSelectedOption } from '@app/actions/subscribeActions';
import RouterConstants from '@app/constants/router';
import colors from '@app/constants/colors';
import {
  Package, PackageContainer, PromoRedemption, Button, ErrorMessage,
} from '@app/components';

const Promotion = ({
  isLoggedIn,
  history,
  setSelectedOptionId,
  option,
  isPurchaseInProgress,
  subscribeSelectedOption,
  error,
}) => (
  <PageContainer>
    {
      error && (
        <ErrorMessage>
          <FormattedMessage id={`payment.errors.${get(error, 'code')}`} />
        </ErrorMessage>
      )
    }
    <PackageContainer centered>
      <Package
        key={option.optionId}
        option={option}
        hasMargin
        selected
      />
      <PromoRedemption showDiscount />
    </PackageContainer>
    <ButtonsContainer>
      <Button
        labelId="subscribe.button.back"
        textColor={colors.ALICE_BLUE}
        backgroundColor={colors.INTERNATIONAL_ORANGE}
        onClick={() => {
          setSelectedOptionId(null);
          history.push(RouterConstants.SUBSCRIBE);
        }}
        disabled={isPurchaseInProgress}
      />
      <Button
        labelId="subscribe.button.next"
        textColor={colors.ALICE_BLUE}
        backgroundColor={colors.INTERNATIONAL_ORANGE}
        disabled={isPurchaseInProgress}
        loading={isPurchaseInProgress}
        onClick={() => {
          if (!isLoggedIn) {
            history.push(RouterConstants.SIGN_UP);
          } else {
            subscribeSelectedOption();
          }
        }}
      />
    </ButtonsContainer>
  </PageContainer>
);

Promotion.propTypes = {
  setSelectedOptionId: PropTypes.func.isRequired,
  subscribeSelectedOption: PropTypes.func.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  option: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isPurchaseInProgress: PropTypes.bool.isRequired,
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
};

Promotion.defaultProps = {
  error: null,
};


const mapStateToProps = ({
  subscribe: { availableOptions = [], isPurchaseInProgress },
  user: { isLoggedIn },
  payment: { error },
}) => (
  {
    option: availableOptions[0],
    isLoggedIn,
    isPurchaseInProgress,
    error,
  }
);

const mapDispatchToProps = { setSelectedOptionId, subscribeSelectedOption };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Promotion));

const PageContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: 300px;
  padding: 20px 0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 40px 0 20px;
  width: 100%;
  max-width: 850px;
`;
